import { Injectable } from "@angular/core";
import { LiquidConstants } from "./liquid.constants";
import { Liquid } from "liquidjs";

@Injectable({
  providedIn: "root",
})
export class LiquidParserService
{
    engine: Liquid;
    lc: LiquidConstants;

     


  constructor(){
    this.engine = new Liquid({cache:true});
    this.lc = new LiquidConstants();
      } 

}
